<template>     
   <div class="navbar-custom">
      <ul class="list-unstyled topbar-menu float-end mb-0">
          <li class="dropdown notification-list d-lg-none">
              <a class="nav-link dropdown-toggle arrow-none" data-bs-toggle="dropdown" href="#" role="button" aria-haspopup="false" aria-expanded="false">
                  <i class="dripicons-search noti-icon"></i> 
              </a>
              <div class="dropdown-menu dropdown-menu-animated dropdown-lg p-0">
                  <form class="p-3">
                      <input type="text" class="form-control" placeholder="Search ..." aria-label="Recipient's username">
                  </form>
              </div>
          </li>
          <!-- <li class="dropdown notification-list topbar-dropdown">
              <a class="nav-link dropdown-toggle arrow-none" data-bs-toggle="dropdown" href="#" role="button" aria-haspopup="false" aria-expanded="false">
                  <img src="assets/images/flags/us.jpg" alt="user-image" class="me-0 me-sm-1" height="12"> 
                  <span class="align-middle d-none d-sm-inline-block">English</span> <i class="mdi mdi-chevron-down d-none d-sm-inline-block align-middle"></i>
              </a>
              <div class="dropdown-menu dropdown-menu-end dropdown-menu-animated topbar-dropdown-menu">
 
                  <a href="javascript:void(0);" class="dropdown-item notify-item">
                      <img src="assets/images/flags/germany.jpg" alt="user-image" class="me-1" height="12"> <span class="align-middle">English</span>
                  </a> 
              </div>
          </li> -->

          <!-- <li class="dropdown notification-list">
              <a class="nav-link dropdown-toggle arrow-none" data-bs-toggle="dropdown" href="#" role="button" aria-haspopup="false" aria-expanded="false">
                  <i class="dripicons-bell noti-icon"></i>
                  <span class="noti-icon-badge"></span>
              </a>
              <div class="dropdown-menu dropdown-menu-end dropdown-menu-animated dropdown-lg">
 
                  <div class="dropdown-item noti-title px-3">
                      <h5 class="m-0">
                          <span class="float-end">
                              <a href="javascript: void(0);" class="text-dark">
                                  <small>Clear All</small>
                              </a>
                          </span>Notification
                      </h5>
                  </div>

                  <div class="px-3" style="max-height: 300px;" data-simplebar>

                      <h5 class="text-muted font-13 fw-normal mt-0">Today</h5> 
                      <a href="javascript:void(0);" class="dropdown-item p-0 notify-item card unread-noti shadow-none mb-2">
                          <div class="card-body">
                              <span class="float-end noti-close-btn text-muted"><i class="mdi mdi-close"></i></span>   
                              <div class="d-flex align-items-center">
                                  <div class="flex-shrink-0">
                                      <div class="notify-icon bg-primary">
                                          <i class="mdi mdi-comment-account-outline"></i>
                                      </div>
                                  </div>
                                  <div class="flex-grow-1 text-truncate ms-2">
                                      <h5 class="noti-item-title fw-semibold font-14">Datacorp <small class="fw-normal text-muted ms-1">1 min ago</small></h5>
                                      <small class="noti-item-subtitle text-muted">Caleb Flakelar commented on Admin</small>
                                  </div>
                                </div>
                          </div>
                      </a>     
                  </div> 
                  <a href="javascript:void(0);" class="dropdown-item text-center text-primary notify-item border-top border-light py-2">
                      View All
                  </a>

              </div>
          </li> -->

          <!-- <li class="dropdown notification-list d-none d-sm-inline-block">
              <a class="nav-link dropdown-toggle arrow-none" data-bs-toggle="dropdown" href="#" role="button" aria-haspopup="false" aria-expanded="false">
                  <i class="dripicons-view-apps noti-icon"></i>
              </a>
              <div class="dropdown-menu dropdown-menu-end dropdown-menu-animated dropdown-lg p-0">

                  <div class="p-2">
                      <div class="row g-0">
                          <div class="col">
                              <a class="dropdown-icon-item" href="#">
                                  <img src="assets/images/brands/slack.png" alt="slack">
                                  <span>Slack</span>
                              </a>
                          </div>
                          
                      </div>

                      <div class="row g-0">
                          <div class="col">
                              <a class="dropdown-icon-item" href="#">
                                  <img src="assets/images/brands/bitbucket.png" alt="bitbucket">
                                  <span>Bitbucket</span>
                              </a>
                          </div>
                          
                      </div>  
                  </div>

              </div>
          </li> -->

          <li class="dropdown notification-list">
              <a class="nav-link nav-user arrow-none me-0 text-danger d-flex align-items-center" href="javascript:void(0);" @click="clearAllStorage()" role="button">
                  <i class="mdi mdi-logout font-22 me-1"></i>
                  <span class="d-flex align-items-center">
                      <span class="account-user-name fw-bold text-dark mb-0">{{userData.user.name}} (Logout)</span>
                  </span>
              </a>
          </li>
      </ul>
      <button class="button-menu-mobile open-left" id="sidebarCollapse" @click="handleResize">
          <i class="mdi mdi-menu"></i>
      </button>   
      
      <div class="d-none d-lg-flex align-items-center" style="position: absolute; top: 50%; transform: translateY(-50%); left: 70px;">
          <router-link to="/pos" class="btn btn-sm btn-outline-primary me-2 fw-bold rounded-pill px-3">
              <i class="mdi mdi-desktop-mac me-1"></i> POS
          </router-link>
          <router-link to="/account-settings/fiscal-year" class="btn btn-sm btn-outline-warning me-2 fw-bold rounded-pill px-3">
              <i class="mdi mdi-calendar-clock me-1"></i> Fiscal-Year Close
          </router-link>
          <router-link to="/reports/cash-book-reports" class="btn btn-sm btn-outline-success fw-bold rounded-pill px-3">
              <i class="mdi mdi-cash-multiple me-1"></i> Cash in Hand
          </router-link>
      </div>
  </div>
</template>
<script>
import { mapState } from 'pinia';
import { useAuthStore } from '@/stores/auth';
import { useCartStore } from '@/stores/cart';
import { useProductStore } from '@/stores/product';
import { useRequisitionProductStore } from '@/stores/requisitionProduct'; 
export default {
  name: 'TopbarTemplate',
  props: {
    msg: String
  },
  data() {
    return {
      routes: this.$router.options.routes,
      activeClass:'', 
    };

  },
  methods:{  
    handleResize() {  
      var mask = document.getElementById('leftside-menu-container'); 
      var body = document.body; 
      var b = document.querySelector("body"); 
      if(b.hasAttribute('data-leftbar-compact-mode')){
        mask.style.overflowY = 'auto';
        b.removeAttribute('data-leftbar-compact-mode');
        document.getElementsByTagName('body')[0].classList.remove('compact-enable');
        document.getElementsByTagName('body')[0].classList.add('sidebar-enable'); 
      }else{ 
        mask.style.overflowY = 'visible';
        b.setAttribute("data-leftbar-compact-mode", "condensed");
        document.getElementsByTagName('body')[0].classList.add('compact-enable');
        document.getElementsByTagName('body')[0].classList.remove('sidebar-enable'); 
      } 
    },

    
    async clearAllStorage() {
      const authStore = useAuthStore();
      const productStore = useProductStore();
      const reqProductStore = useRequisitionProductStore();
      // No removeAllRoutes in Pinia
      await productStore.removeAllProducts();
      await reqProductStore.removeAllRequitionProduct();
      await authStore.logout();
      this.$router.push({ name: 'Login' });
    },

     
  },
  computed: { 
    ...mapState(useAuthStore, ["userData"]), 
    computedClass() {
      if(this.currentRouteName =='/pos'){
        return 'active';
      }else{
        return '';
      }  
    },
    currentRouteName() {
        return this.$route.path;
    }, 
  },
  mounted() { 
    
  },
  created(){ 

  }
}
</script>